import React, {
  ChangeEvent,
  InputHTMLAttributes,
  useEffect,
  useState,
} from 'react';
import { AccountType } from 'types/userTypes';

interface AccountFormInputProps extends InputHTMLAttributes<HTMLInputElement> {
  syncAccount: (newValue: Partial<AccountType>) => void;
  validation?: (value: string) => string;
}

export const AccountFormInput = (props: AccountFormInputProps): JSX.Element => {
  const [word, setWord] = useState(props.value);

  /* Always update the Input Value whenever the `Account` value changed */
  useEffect(() => {
    setWord(props.value);
  }, [props.value]);

  const onInputChange = (evt: ChangeEvent<HTMLInputElement>) => {
    const inputValue = evt.target.value;
    const newValue = props.validation
      ? props.validation(inputValue)
      : inputValue;
    setWord(newValue);

    const newAccount = { [props.name]: newValue };
    props.syncAccount(newAccount);
  };

  return <input {...props} value={word} onChange={onInputChange} />;
};
